import React, { Component } from "react";
import { withRouter } from "react-router";
import LineEchart from "./LineEchart";
import "./lineEchartPerformanceTrends.css";
import {getSuperFundProductIncome} from '../action/portfolioAction'
import { connect } from "react-redux";
import Util from "../util";

class LineEchartPerformanceTrends extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
    };
  }
  componentWillMount(){
    console.log('props',this.props)
  }
  
  formatter = (params) => {
    console.log('params',params)
   const getColor = (value) => {
      if (!value&&value!=0) return;
      if (value === "--") return "#333";
      if (value >= 0) return "#F8515C";
      return "#1DA96B";
    };
    if (params && params.length === 1 && params[0] && params[0].seriesName === '业绩基准') { params[1] = params[0]; params[0] = null; }
    return `<div class="PT_describe">
              <div class="PT_data">本策略 <span class='PT_describe_colon'>:</span> <span style='color:${getColor(params[0]&&params[0].value[1])}'>${Util.toPercent(params[0]&&params[0].value[1])}</span></div>
              <div class="PT_base_data">业绩基准 <span class='PT_describe_colon'>:</span> <span style='color:${getColor(params[1]&&params[1].value[1])}'>${Util.toPercent(params[1]&&params[1].value[1]) }</span></div>
              <img style=' width: .24rem; margin-left: .1rem ' src='${require("../img/n_icon_what@2.png")}' />
            </div>`;
  };
  changeTab = (index) => {
    const periodType = [1, 3, 6, 12, 36];
    let { dispatch, location,lineData } = this.props;
    const key=periodType[index]
    const echartsDOM= document.querySelector("#tip");
    if(echartsDOM)echartsDOM.style.display = "flex";
    if (index == this.state.tab) return;
    // document.querySelector('#tip').style.display='flex'
    this.setState({ tab: index });
    if(periodType[index] in lineData) return ; 
    const params = {
      superFundCode: location.query.superFundCode,
      periodType: periodType[index],
    };
    dispatch(getSuperFundProductIncome(params));
    
  };
  render() {
    const btn = ["近1月", "近3月", "近6月", "近1年", "近3年"];
    const periodType = [1, 3, 6, 12, 36];
    const linelist=this.props.lineData[periodType[this.state.tab]] ?this.props.lineData[periodType[this.state.tab]]:{}
    const {incomeDateList: xData,incomeList4Benchmark: baseData, incomeList:data,incomeDateList4Benchmark:xBase } = linelist;
    return (
      <div className="PT_container">
        <LineEchart lineDataLast={this.props.lineDataLast} formatter={this.formatter} xData={xData} baseData={baseData} data={data} xBase={xBase} />
        <div className="PT_btn_group">
          {btn.map((item, index) => {
            return (
              <div onClick={() => this.changeTab(index)} key={index} className={this.state.tab == index && "Tab_Selected"}>
                {item}
              </div>
            );
          })}
        </div>
        <div className="PT_tip">业绩走势为根据策略组合持仓基金净值波动计算结果，未考虑成分基金交易费用，与用户实际收益可能略有差异。</div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    lineData: state.lineData,
    lineDataLast:state.lineDataLast
  };
}

export default withRouter(connect(mapStateToProps)(LineEchartPerformanceTrends));



// WEBPACK FOOTER //
// ./src/components/LineEchartPerformanceTrends.js